import React from 'react'
import withoutAuthentication from '../components/withoutAuthentication'
import SignInPage from '../components/SignIn/Page'

const ScreensSignIn = () => <SignInPage />

export default withoutAuthentication()(ScreensSignIn)
